<template>
  <div class="course-container">
    <headerPage></headerPage>
    <div class="announcement-detail">
      <!-- 返回按钮 -->
      <el-page-header @back="goBack"  class="return-button"></el-page-header>
      <h1 class="announcement-title">{{ announcement.title }}</h1>
      <p class="announcement-date">{{ formatDate(announcement.createTime) }}</p>
      <hr class="announcement-divider">
      <div v-html="parsedContent" class="announcement-content"></div>
    </div>
    <bottomPage></bottomPage>
  </div>
</template>

<script>
import { gitNoticeById } from '@/api';
import moment from'moment';
import headerPage from "@/components/header/header.vue";
import bottomPage from "@/components/bottom/bottom.vue";
import { Parser } from 'htmlparser2';

export default {
  components: { bottomPage, headerPage },
  data() {
    return {
      announcement: {
        title: '',
        createTime: '',
        content: ''
      },
      parsedContent: ''
    };
  },
  async created() {
    const id = this.$route.params.id;
    try {
      const response = await gitNoticeById(id);
      this.announcement = {
        title: response.data.title,
        createTime: response.data.createTime,
        content: response.data.content
      };
      this.parseContent();
    } catch (error) {
      console.error('获取公告详情失败:', error);
    }
  },
  methods: {
    parseContent() {
      let result = '';
      const parser = new Parser({
        onopentag(name, attribs) {
          let tag = `<${name}`;
          for (const [key, value] of Object.entries(attribs)) {
            tag += ` ${key}="${value}"`;
          }
          tag += '>';
          result += tag;
        },
        ontext(text) {
          result += text;
        },
        onclosetag(name) {
          result += `</${name}>`;
        }
      });
      parser.write(this.announcement.content);
      parser.end();
      this.parsedContent = result;
    },
    formatDate(timestamp) {
      return moment(timestamp).format('YYYY-MM-DD');
    },
    // 返回首页
    goBack() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
/* 页面容器样式 */
.course-container {
  background-color: #f5f5f5;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.announcement-detail {
  height: 100%;
  margin: 20px;
}

.announcement-title {
  text-align: center;
  margin-top: 0; /* 去除标题顶部外边距 */
  padding-top: 0; /* 去除标题顶部内边距 */
}

.announcement-date {
  color: #888;
  margin-bottom: 10px;
  text-align: center;
}

.announcement-divider {
  border: none;
  border-top: 1px solid #ccc;
  margin: 20px 0;
}

.announcement-content {
  line-height: 1.6;
  margin: 0 200px; /* 设置左右间距为 200px */
  max-height: 60vh; /* 设置最大高度，可根据实际情况调整 */
  overflow-y: auto; /* 当内容超出最大高度时显示垂直滚动条 */
}
</style>
